import { createMarketsApi } from "@/v2/api/metadata/markets";
import { createOutcomesApi } from "@/v2/api/metadata/outcomes";
import { createSportsApi } from "@/v2/api/metadata/sports";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { EntityView } from "@/v2/framework/view/types";
import { columns, dynamicColumnSlots } from "./columns";
import { createDialogs } from "./dialogs";
import { createFilters } from "./filters";

const LS_OUTCOMES_FILTERS_KEY = Symbol("outcomes-filters");

export function createOutcomesView(ctx: BackofficeContext): EntityView {
  const outcomesApi = createOutcomesApi(ctx);
  const sportsApi = createSportsApi(ctx);
  const marketsApi = createMarketsApi(ctx);

  return {
    id: "outcomes",
    view: [
      {
        type: "grid",
        columns,
        filters: createFilters({ ctx, sportsApi, marketsApi }),
        dynamicColumnSlots,
        dialogs: createDialogs({ ctx, outcomesApi, marketsApi }),
        syncRouteQuery: true,
        syncRouteDialog: true,
        hasExport: true,
        filtersKey: LS_OUTCOMES_FILTERS_KEY,
        allowSaveFilters: true,
        hasSearch: true,
        api: outcomesApi.grid,
      },
    ],
  };
}
